(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab-mission"] && !Shopify.designMode) return;
  try {
    
  class AboutMission extends HTMLElement {
    connectedCallback() {
      const reveals = Array.from(this.querySelectorAll('[data-ab-reveal]'));
      if (reveals.length === 0) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (const el of reveals) el.classList.add('is-revealed');
        return;
      }
      const obs = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target;
          el.style.transitionDelay = `${reveals.indexOf(el) * 90}ms`;
          requestAnimationFrame(() => el.classList.add('is-revealed'));
          obs.unobserve(el);
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
      for (const el of reveals) obs.observe(el);
    }
  }
  if (!customElements.get('about-mission')) {
    customElements.define('about-mission', AboutMission);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-stats"] && !Shopify.designMode) return;
  try {
    
  class AboutStats extends HTMLElement {
    connectedCallback() {
      this.reveals = Array.from(this.querySelectorAll('[data-ab-reveal]'));
      this.values = Array.from(this.querySelectorAll('[data-stat-value]'));
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!('IntersectionObserver' in window)) {
        for (const el of this.reveals) el.classList.add('is-revealed');
        for (const el of this.values) this.#setFinal(el);
        return;
      }

      this.obs = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target;
          if (el.hasAttribute('data-ab-reveal')) {
            const sibs = this.reveals;
            el.style.transitionDelay = `${Math.min(sibs.indexOf(el), 8) * 80}ms`;
            requestAnimationFrame(() => el.classList.add('is-revealed'));
          }
          if (el.hasAttribute('data-stat-value')) {
            this.#animate(el);
          }
          this.obs.unobserve(el);
        }
      }, { threshold: 0.3, rootMargin: '0px 0px -30px 0px' });

      for (const el of this.reveals) this.obs.observe(el);
      for (const el of this.values) this.obs.observe(el);
    }

    disconnectedCallback() {
      this.obs?.disconnect();
    }

    #setFinal(el) {
      const target = parseFloat(el.dataset.statValue) || 0;
      const dec = parseInt(el.dataset.statDecimals, 10) || 0;
      el.textContent = this.#format(target, dec);
    }

    #animate(el) {
      const target = parseFloat(el.dataset.statValue) || 0;
      const dec = parseInt(el.dataset.statDecimals, 10) || 0;
      const duration = parseInt(el.dataset.statDuration, 10) || 1600;

      if (this.reduce || duration === 0) {
        el.textContent = this.#format(target, dec);
        return;
      }

      const start = performance.now();
      const ease = (t) => 1 - Math.pow(1 - t, 3);
      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const current = target * ease(progress);
        el.textContent = this.#format(current, dec);
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = this.#format(target, dec);
      };
      requestAnimationFrame(step);
    }

    #format(num, dec) {
      return num.toLocaleString('de-DE', {
        minimumFractionDigits: dec,
        maximumFractionDigits: dec,
      });
    }
  }
  if (!customElements.get('about-stats')) {
    customElements.define('about-stats', AboutStats);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-timeline"] && !Shopify.designMode) return;
  try {
    
  class AboutTimeline extends HTMLElement {
    connectedCallback() {
      const reveals = Array.from(this.querySelectorAll('[data-ab-reveal]'));
      if (reveals.length === 0) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (const el of reveals) el.classList.add('is-revealed');
        return;
      }
      const obs = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          requestAnimationFrame(() => entry.target.classList.add('is-revealed'));
          obs.unobserve(entry.target);
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      for (const el of reveals) obs.observe(el);
    }
  }
  if (!customElements.get('about-timeline')) {
    customElements.define('about-timeline', AboutTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-values-aura"] && !Shopify.designMode) return;
  try {
    
  class AboutValues extends HTMLElement {
    connectedCallback() {
      const reveals = Array.from(this.querySelectorAll('[data-ab-reveal]'));
      if (reveals.length === 0) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (const el of reveals) el.classList.add('is-revealed');
        return;
      }
      const obs = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target;
          const grid = el.closest('.ab-values__grid');
          if (grid) {
            const sibs = Array.from(grid.children);
            el.style.transitionDelay = `${Math.min(sibs.indexOf(el), 8) * 80}ms`;
          }
          requestAnimationFrame(() => el.classList.add('is-revealed'));
          obs.unobserve(el);
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      for (const el of reveals) obs.observe(el);
    }
  }
  if (!customElements.get('about-values')) {
    customElements.define('about-values', AboutValues);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-values"] && !Shopify.designMode) return;
  try {
    
  class AboutValues extends HTMLElement {
    connectedCallback() {
      const reveals = Array.from(this.querySelectorAll('[data-ab-reveal]'));
      if (reveals.length === 0) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (const el of reveals) el.classList.add('is-revealed');
        return;
      }
      const obs = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target;
          const grid = el.closest('.ab-values__grid');
          if (grid) {
            const sibs = Array.from(grid.children);
            el.style.transitionDelay = `${Math.min(sibs.indexOf(el), 8) * 80}ms`;
          }
          requestAnimationFrame(() => el.classList.add('is-revealed'));
          obs.unobserve(el);
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      for (const el of reveals) obs.observe(el);
    }
  }
  if (!customElements.get('about-values')) {
    customElements.define('about-values', AboutValues);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-person"] && !Shopify.designMode) return;
  try {
    
  class AboutPerson extends HTMLElement {
    connectedCallback() {
      const reveals = Array.from(this.querySelectorAll('[data-abp-reveal]'));
      if (reveals.length === 0) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (const el of reveals) el.classList.add('is-revealed');
        return;
      }
      const obs = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target;
          el.style.transitionDelay = `${Math.min(reveals.indexOf(el), 8) * 70}ms`;
          requestAnimationFrame(() => el.classList.add('is-revealed'));
          obs.unobserve(el);
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
      for (const el of reveals) obs.observe(el);
    }
  }
  if (!customElements.get('about-person')) {
    customElements.define('about-person', AboutPerson);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-ritual-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section) return;
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const animEnabled = section.dataset.auraEnableAnim === 'true' && !prefersReduced;

      const reveals = section.querySelectorAll('[data-aura-reveal]');

      if (!animEnabled || !('IntersectionObserver' in window)) {
        reveals.forEach((el) => el.classList.add('is-revealed'));
      } else {
        const stagger = Math.max(0, parseInt(section.dataset.auraStagger || '90', 10));

        const observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const el = entry.target;

            // Stagger cards inside the same grid container
            if (el.classList.contains('aura-card')) {
              const grid = el.closest('.aura-side-grid, .aura-wave-grid, .aura-constellation__row');
              if (grid) {
                const siblings = Array.from(grid.querySelectorAll('.aura-card'));
                const idx = siblings.indexOf(el);
                el.style.transitionDelay = `${idx * stagger}ms`;
              }
            }

            requestAnimationFrame(() => el.classList.add('is-revealed'));
            observer.unobserve(el);
          }
        }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

        reveals.forEach((el) => observer.observe(el));
      }

      // Mystical hover light tracking
      if (section.classList.contains('aura-card--mystical') && !window.matchMedia('(hover: none)').matches) {
        section.querySelectorAll('.aura-card').forEach((card) => {
          card.addEventListener('pointermove', (e) => {
            const r = card.getBoundingClientRect();
            card.style.setProperty('--mx', `${((e.clientX - r.left) / r.width) * 100}%`);
            card.style.setProperty('--my', `${((e.clientY - r.top) / r.height) * 100}%`);
          });
        });
      }
    };

    const boot = () => document.querySelectorAll('.aura-showcase').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.aura-showcase');
      if (section) init(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-faq-aura"] && !Shopify.designMode) return;
  try {
    
  class ContactFaq extends HTMLElement {
    connectedCallback() {
      const reveals = Array.from(this.querySelectorAll('[data-cq-reveal]'));
      if (reveals.length === 0) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (const el of reveals) el.classList.add('is-revealed');
        return;
      }
      const obs = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target;
          el.style.transitionDelay = `${Math.min(reveals.indexOf(el), 8) * 70}ms`;
          requestAnimationFrame(() => el.classList.add('is-revealed'));
          obs.unobserve(el);
        }
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      for (const el of reveals) obs.observe(el);
    }
  }
  if (!customElements.get('contact-faq')) {
    customElements.define('contact-faq', ContactFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form-aura"] && !Shopify.designMode) return;
  try {
    
  class ContactFormSection extends HTMLElement {
    connectedCallback() {
      const reveals = Array.from(this.querySelectorAll('[data-cf-reveal]'));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (const el of reveals) el.classList.add('is-revealed');
      } else {
        const obs = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const el = entry.target;
            el.style.transitionDelay = `${Math.min(reveals.indexOf(el), 6) * 90}ms`;
            requestAnimationFrame(() => el.classList.add('is-revealed'));
            obs.unobserve(el);
          }
        }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
        for (const el of reveals) obs.observe(el);
      }
      const success = this.querySelector('.cform__success');
      if (success) success.focus();
    }
  }
  if (!customElements.get('contact-form-section')) {
    customElements.define('contact-form-section', ContactFormSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-info-aura"] && !Shopify.designMode) return;
  try {
    
  class ContactInfo extends HTMLElement {
    connectedCallback() {
      const reveals = Array.from(this.querySelectorAll('[data-ci-reveal]'));
      if (reveals.length === 0) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (const el of reveals) el.classList.add('is-revealed');
        return;
      }
      const obs = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target;
          const grid = el.closest('.cinfo__grid');
          if (grid) {
            const sibs = Array.from(grid.children);
            el.style.transitionDelay = `${Math.min(sibs.indexOf(el), 8) * 80}ms`;
          }
          requestAnimationFrame(() => el.classList.add('is-revealed'));
          obs.unobserve(el);
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      for (const el of reveals) obs.observe(el);
    }
  }
  if (!customElements.get('contact-info')) {
    customElements.define('contact-info', ContactInfo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
  class HotspotSection extends HTMLElement {
    connectedCallback() {
      this.trigger = this.dataset.trigger || 'click';
      this.points = Array.from(this.querySelectorAll('.hotspots__point'));

      for (const point of this.points) this.#bindPoint(point);
    }

    #bindPoint(point) {
      const button = point.querySelector('[data-hotspot-trigger]');
      const panel = point.querySelector('[data-hotspot-panel]');
      const close = point.querySelector('[data-hotspot-close]');
      if (!button || !panel) return;

      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.#open(button, panel);
      });

      // Hover-Modus: auf Desktop bei Mouse-Enter öffnen
      if (this.trigger === 'hover') {
        point.addEventListener('pointerenter', () => {
          if (window.matchMedia('(hover: hover)').matches) this.#open(button, panel);
        });
      }

      close?.addEventListener('click', () => panel.close());

      // Klick auf Backdrop (außerhalb des Inhalts) schließt
      panel.addEventListener('click', (event) => {
        if (event.target === panel) panel.close();
      });

      // Beim Schließen: aria zurücksetzen + Fokus zum Punkt
      panel.addEventListener('close', () => {
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      });
    }

    #open(button, panel) {
      if (panel.open) return;
      if (typeof panel.showModal === 'function') {
        panel.showModal();
      } else {
        // Fallback für sehr alte Browser
        panel.setAttribute('open', '');
      }
      button.setAttribute('aria-expanded', 'true');
    }
  }

  if (!customElements.get('hotspot-section')) {
    customElements.define('hotspot-section', HotspotSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-blocks-aura"] && !Shopify.designMode) return;
  try {
    
  class ImageBlocks extends HTMLElement {
    connectedCallback() {
      this.reveals = Array.from(this.querySelectorAll('[data-ib-reveal]'));
      if (this.reveals.length === 0) return;

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (const el of this.reveals) el.classList.add('is-revealed');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const el = entry.target;
            const siblings = this.reveals;
            const index = siblings.indexOf(el);
            el.style.transitionDelay = `${Math.min(index, 6) * 80}ms`;
            requestAnimationFrame(() => el.classList.add('is-revealed'));
            this.observer.unobserve(el);
          }
        },
        { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
      );

      for (const el of this.reveals) this.observer.observe(el);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('image-blocks')) {
    customElements.define('image-blocks', ImageBlocks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  class VideoBanner extends HTMLElement {
    connectedCallback() {
      this.#initReveal();
      this.#initVideo();
    }

    #initReveal() {
      const reveals = Array.from(this.querySelectorAll('[data-vb-reveal]'));
      if (reveals.length === 0) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (const el of reveals) el.classList.add('is-revealed');
        return;
      }
      const obs = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target;
          el.style.transitionDelay = `${Math.min(reveals.indexOf(el), 6) * 90}ms`;
          requestAnimationFrame(() => el.classList.add('is-revealed'));
          obs.unobserve(el);
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
      for (const el of reveals) obs.observe(el);
    }

    #initVideo() {
      const wrap = this.querySelector('[data-vb-video]');
      if (!wrap) return;
      const video = wrap.querySelector('.vb__video-el');
      const playBtn = wrap.querySelector('[data-vb-play]');
      if (!video || !playBtn) return;

      playBtn.addEventListener('click', () => {
        wrap.classList.add('is-playing');
        video.setAttribute('controls', '');
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
        video.focus({ preventScroll: true });
      });
    }
  }

  if (!customElements.get('video-banner')) {
    customElements.define('video-banner', VideoBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
